import { useState } from 'react';

import { useIsomorphicLayoutEffect } from '@weberus/ui/hooks/use-isomorphic-layout-effect';
import { Units } from '@weberus/ui/styles';
import throttle from 'lodash-es/throttle';

/**
 * device 자체가 pc인지 확인하는 것이 아니라, pc 해상도인지 확인하는 것이다.
 * 따라서, 모바일에서도 pc 해상도로 접속하면 pc로 인식하고, pc에서도 모바일 해상도로 접속하면 모바일로 인식한다.
 * 만약 device 자체가 pc인지 확인하고 싶다면, with-device-os.ts를 참고
 * */
export const useIsPcWidth = (): boolean => {
  const [isPcWidth, setIsPcWidth] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const checkIsPcWidth = throttle(() => {
      setIsPcWidth(window.innerWidth >= Units.PC_WIDTH);
    }, 250);
    window.addEventListener('resize', checkIsPcWidth);
    checkIsPcWidth();
    return () => {
      window.removeEventListener('resize', checkIsPcWidth);
    };
  }, []);
  return isPcWidth;
};
